$(document).ready(function(){
  function selectValueBtn(){  
             setTimeout(function() { 
             var hatColor =   $('.newlayout-prsnlize-hatcolor').find('span.mw-text.mw-accumulated-title[data-mw-option-accumulated-title]').text().toLowerCase();
             var hatbandColor = $('.new-layout-persnilzer-hatbandcolor').find('span.mw-text.mw-accumulated-title[data-mw-option-accumulated-title]').text().toLowerCase();
            
             console.log("Hat bandColor - ", hatbandColor);  
             var makeCombination = hatColor.trim() + ' / ' + hatbandColor.trim();
             //alert(hatColor + ' / ' + hatbandColor)
             $(document).find('.mw-option--type-button.combination-swatch').find('span.mw-text.mw-option__value-text').each(function(){
               var _thisCombineText = $(this).text().toLowerCase().trim();
               if(makeCombination === _thisCombineText){
                 if ($(this).parents('label.mw-label').hasClass('clickTheElem')) {
                   return;
                 }
                  $(this).parents('label.mw-label').addClass('clickTheElem');
                  $(this).parents('label.mw-label').trigger('click');
                 console.log('NewLayout -- 0001 = ' + _thisCombineText  );

                 var this__78 = this;
                 setTimeout (function() {
                   $(this__78).parents('label.mw-label').removeClass('clickTheElem');
                 }, 1000);
               } else {
                 //console.log('Else NewLayout = ' + _thisCombineText  )
               }
             });   
          if($(document).find('.new-layout-persnilzer-hatbandcolor .small-swatch[data-color="'+hatbandColor.trim()+'"]').length){}else{
              $(".new-layout-persnilzer-hatbandcolor span.small-swatch").remove();
              $('<span class="small-swatch" data-color="'+hatbandColor.trim()+'"></span>').insertAfter( ".new-layout-persnilzer-hatbandcolor span.mw-text.mw-accumulated-title" );
          }
 
               $('.image_product').fadeOut('slow', function(){
     setTimeout(function() { 
        $('#image_product').fadeIn('slow');
          }, 500);  
    });
         }, 300);  
  }
  
         setTimeout(function() { 
             if($(document).find('.mw-apo-container').length){ 
                 selectValueBtn(); 
              }  
          }, 300); 

/* $(document).on('click', '.newlayout-material-option .mw-option__value:nth-child(1) .mw-option__button', function(){
    
      if($(document).find(".newlayout-prsnlize-hatcolor .mw-hidden[data-helptext-type='required']").length){
        console.log('hidden')
      }else{
         setTimeout(function() { 
        console.log('not')
        $('.newlayout-prsnlize-hatcolor span.mw-text.mw-accumulated-title').text('Not available in pure beaver');
             }, 500); 
      }    
   
  });*/


  
  function checkPresnlizevalue() {
        var hatbandColor = $('.new-layout-persnilzer-hatbandcolor').find('span.mw-text.mw-accumulated-title[data-mw-option-accumulated-title]').text().toLowerCase();
        if($(document).find('.new-layout-persnilzer-hatbandcolor .small-swatch').length){}else{
              $(".new-layout-persnilzer-hatbandcolor span.small-swatch").remove();
              $('<span class="small-swatch" data-color="'+hatbandColor.trim()+'"></span>').insertAfter( ".new-layout-persnilzer-hatbandcolor span.mw-text.mw-accumulated-title" );
        }

        var getHtml =  $('.standardProductpersonalisation').html();  
                   if($(document).find('.hatsize_comment').length){
                    $(".hatsize_comment").addClass('testITG');
                    if($(document).find('.addpresnlizevalue').length){}else{
                      $(".hatsize_comment").prepend('<div class="addpresnlizevalue">' + getHtml + '</div>');
                    } 
                  }

    if ($('.newlayout-prsnlize-hatcolor span.mw-text.mw-accumulated-title').is(':empty')){
        $('.newlayout-prsnlize-hatcolor span.mw-text.mw-accumulated-title').text('Not available');
      //  $('.newlayout-prsnlize-hatcolor span.mw-text.mw-accumulated-title').css('color', 'red');
    }
}

var interval = self.setInterval(function(){checkPresnlizevalue()},2000);
  
  $(document).on('click', '.newlayout-prsnlize-hatcolor .mw-option__value .mw-option__swatch-color', function(){ 
     selectValueBtn();
  });

  $(document).on('click', '.new-layout-persnilzer-hatbandcolor .mw-option__value .mw-label', function(){
    selectValueBtn();

      setTimeout(function() { 
          $('.new-layout-persnilzer-hatbandcolor .mw-stack__item:nth-child(2)').hide();   
     }, 200); 
  });


 

  /******************/
    $(document).on('click', '.new-layout-persnilzer-hatbandcolor span.mw-text.mw-text--style-strong', function(){
        $('.new-layout-persnilzer-hatbandcolor .mw-stack__item:nth-child(2)').toggle();
    });

  /******************/
    $(document).on('click', 'div#standard-Personalisation', function(){
        $('.newlayout-customize').hide();
        $('.addpresnlizevalue').hide();
      // $('.newlayout-customize').css('visibility','hidden');
     //  $('.addpresnlizevalue').css('visibility','hidden');
    });

    $(document).on('click', '.arrow-right.Standard-personalisation', function(){
        $('.newlayout-customize').show();
      $('.addpresnlizevalue').show();
      // $('.newlayout-customize').css('visibility','visible');
     //  $('.addpresnlizevalue').css('visibility','visible');
   });

   /******************/
});









